import { useCallback } from 'react';
import { useCachedResource } from './useCachedResource'; // Adjust import path
import { SiteService } from '@/services/SiteService';
import { appConfig } from '@/lib/AppConfig';

interface Site {
  name: string;
}

export const useSiteName = (siteId?: string) => {
  // Memoize the fetch function to preserve the context
  const fetchSite = useCallback(async (id: string) => {
    return await SiteService.getSiteById(id);
  }, []);

  const { data, isLoading, error } = useCachedResource<Site>(
    siteId,
    appConfig.resourceTypes.site,
    fetchSite
  );

  return { siteName: data?.name || null, isLoading, error };
};